export function formatCurrency(value, currency = "PEN") {
    const amount = Number(value || 0);
    return new Intl.NumberFormat("es-PE", {
        style: "currency",
        currency,
    }).format(amount);
}